import { z } from "zod";
import { PublicIdSchema } from "./common";

/**
 * 給油記録. 1 日 attendance に最大 3 件 (sequence 1-3) を紐付ける.
 * liters は decimal 文字列 ("35.20"), amount は整数円.
 */
const RefuelingBase = z.object({
  public_id: PublicIdSchema,
  attendance_public_id: PublicIdSchema,
  sequence: z.number().int().min(1).max(3),
  liters: z.string(),
  amount: z.number().int().min(0),
  refueled_at: z.iso.datetime({ offset: true }),
  created_at: z.iso.datetime({ offset: true }),
});

/** Repository 内部で扱う給油記録。receipt_image_path は外部 API に返さない。 */
export const Refueling = RefuelingBase.extend({
  receipt_image_path: z.string().nullable(),
});

/** Driver API が返す公開用給油記録。領収書は期限付き URL のみ公開する。 */
export const DriverRefueling = RefuelingBase.extend({
  receipt_image_url: z.string().nullable(),
});

export const CreateRefuelingInput = z.object({
  sequence: z.number().int().min(1).max(3).optional(),
  liters: z.string().min(1),
  amount: z.number().int().min(0),
  receipt_image_path: z.string().optional(),
  refueled_at: z.iso.datetime({ offset: true }).optional(),
});

export const UpdateRefuelingInput = z
  .object({
    liters: z.string().min(1).optional(),
    amount: z.number().int().min(0).optional(),
    refueled_at: z.iso.datetime({ offset: true }).optional(),
  })
  .strict()
  .refine(
    (input) =>
      input.liters !== undefined || input.amount !== undefined || input.refueled_at !== undefined,
    {
      message: "更新項目を1つ以上指定してください",
    },
  );

export type RefuelingDto = z.infer<typeof Refueling>;
export type DriverRefuelingDto = z.infer<typeof DriverRefueling>;
export type CreateRefuelingInputDto = z.infer<typeof CreateRefuelingInput>;
export type UpdateRefuelingInputDto = z.infer<typeof UpdateRefuelingInput>;
